import {Component, Vue} from 'vue-property-decorator';

@Component
export default class IconsMixin extends Vue {

    protected hasIcon(icons: {imageUrl: string, logo: string}): boolean {
        return Boolean(icons.imageUrl || icons.logo);
    
    }
    protected useLogo(icons: {imageUrl: string, logo: string}): boolean {
        return Boolean(icons && ((!icons.imageUrl && icons.logo)
        || (icons.imageUrl && icons.imageUrl.includes('placeholder.com') && icons.logo)));
    
    }
    protected getImg(imageUrl: string, index: number = 0, size:string|number = 300, backgroundColor: string = '', textColor: string = '000', text: string = 'IMAGE PLACEHOLDER'): string {
        if (imageUrl) {
            // By default images are stored in /logos but if it starts with `https://` we'll allow it
            return imageUrl.startsWith('/') || imageUrl.startsWith('https://') ? imageUrl : `/${imageUrl}`;
        }
        let bkgColor = backgroundColor;
        if (!backgroundColor) {
            bkgColor = (index + 1) % 2 == 0 ? 'f1f1f1' : 'fff';
        }
        return `https://via.placeholder.com/${size}/${bkgColor}/${textColor}.png?text=${text}`;
    }
}